<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6 mt-3 float-right">
                <b-button variant="primary" class="mb-2 float-right btn-custom" @click="showModal('Add')"><font-awesome-icon icon="plus"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-5"></div>
        <paginated-table ref="dataTable" :can-delete="true" :can-show="false" :can-edit-modal="true" v-on:editData="showEditModal" :can-edit="false" :can-reject="false" :can-approve="false" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns">
        </paginated-table>
        <b-modal ref="my-modal" centered hide-footer :title="type + ' Reimbursement Type'">
            <form v-on:submit.prevent="doSubmit">
                <label for="" class="mt-3">Name *</label>
                <b-form-input type="text" class="mb-3" placeholder="Enter name reimbursement type" v-model="model.name" name="name" v-bind:class="errors.has('name') ? 'is-invalid':''" v-validate="'required'"></b-form-input>
                <b-button class="mt-3" variant="secondary" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
                <b-button class="mt-3 float-right" variant="primary" type="submit"><font-awesome-icon icon="save"></font-awesome-icon>{{this.model.uuid !== null ? ' Update' : ' Submit'}} </b-button>
            </form>
        </b-modal>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    export default {
        name: 'Reimbursement-type',
        components: {
            PaginatedTable
        },
        data () {
            return {
                dataKey: 'reimbursementType',
                apiUrl: window.AppConfig.apiUrl + 'reimbursement-type',
                type: null,
                model: {
                    uuid: null,
                    name: null
                },
                columns: [
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'createdAt',
                        label: 'Created',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: ''
                    }
                ]
            }
        },
        methods: {
            showModal(type) {
                this.model.name = null
                this.model.uuid = null
                this.$validator.reset();
                this.type = type
                this.$refs['my-modal'].show()
            },
            hideModal() {
                this.$refs['my-modal'].hide()
            },
            showEditModal (row) {
                this.type = row.type
                this.model.name = row.name
                this.model.uuid = row.uuid
                this.$refs['my-modal'].show()
            },
            doSubmit () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        if (this.model.uuid !== null) {
                            this.$http.patch(this.apiUrl + '/' + this.model.uuid, {
                                name: this.model.name
                            }).then(response => {
                                this.$store.dispatch('notification/success', 'Reimbursement Type has been updated.')
                                this.$refs.dataTable.doFilter()
                                this.hideModal()
                            }).catch(error => {
                                this.$store.dispatch('notification/error', error)
                            })
                        } else {
                            this.$http.post(this.apiUrl, {
                                name: this.model.name
                            }).then(response => {
                                this.$store.dispatch('notification/success', 'Reimbursement Type has been added.')
                                this.$refs.dataTable.doFilter()
                                this.hideModal()
                            }).catch(error => {
                                this.$store.dispatch('notification/error', error)
                            })
                        }
                    }
                })
            }
        }
    }
</script>